module.exports = __webpack_public_path__ + "static/media/pootsy-logo-white.59cd94f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/pootsy-logo-white.png
// module id = 46
// module chunks = 0